import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export default Container;
